import axios from '@/utils/request';

const userApi = {
  getWorkUnits() {
    return axios({
      url: '/api/v1/workUnit/authorized',
      method: 'get',
    });
  },

  getWorkUnitStatus(workUnitId) {
    return axios({
      url: `/api/v1/workUnit/status/${workUnitId}`,
      method: 'get',
    });
  },

  getWorkUnitDetail() {
    return axios({
      url: '/api/v1/workUnit/detail',
      method: 'get',
    });
  },

  changePwd(data) {
    return axios({
      url: '/api/v1/auth/updatePassword',
      method: 'post',
      data,
    });
  },

  isUserAuthLive() {
    return axios({
      url: '/api/v1/auth/isUserAuthLive',
      method: 'get',
    });
  },

  /**
   * 测试单个工作单元服务器连接状态
   */
  testConnection(id) {
    return axios({
      url: `/api/v1/external/connection/onlineStatus/test/${id}`,
      method: 'POST',
    });
  },

  /**
   * 批量测试工作单元服务器连接状态
   */
  batchTestConnection(data) {
    return axios({
      url: '/api/v1/external/connection/onlineStatus/test/batch',
      method: 'POST',
      data,
    });
  },

  /**
  * 新增外部链接配置
  */
  addServerConfig(data) {
    return axios({
      url: '/api/v1/external/connection/add',
      method: 'POST',
      data,
    });
  },

  /**
  * 更新工作单元服务器配置
  */
  updateServerConfig(data) {
    return axios({
      url: '/api/v1/external/connection/update',
      method: 'POST',
      data,
    });
  },

  /**
  * 删除工作单元服务器配置
  */
  deleteServerConfig(id) {
    return axios({
      url: `/api/v1/external/connection/delete/${id}`,
      method: 'post',
    });
  },

  /**
  * 分页查询工作单元服务器配置信息
  */
  getServerList(params) {
    return axios({
      url: '/api/v1/external/connection/page',
      method: 'get',
      params,
    });
  },

  /**
  * 获取当前用户已授权的工作单元服务器列表
  */
  getAuthorizedServerList(params) {
    return axios({
      url: '/api/v1/external/connection/detail/page',
      method: 'get',
      params,
    });
  },
};

export default userApi;
